<app-header></app-header>
<div class="mainContent-custom">
  <router-outlet></router-outlet>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
<app-toasts-container></app-toasts-container>
